import _ from "lodash";

export const FASCIA_SPEDIZIONE_PATH = "datiUlteriori.web.fasciaPrezziSpedizione.valueId";
export const METODO_SPEDIZIONE_PATH = "datiUlteriori.web.metodoSpedizione.valueId";

const optionId = (config, field, desc) => {
  const options = config?.web?.[field]?.dati;
  const option = Array.isArray(options)
    ? options.find((item) => item?.desc === desc)
    : undefined;
  return option?.idPS == null || option.idPS === "" ? null : String(option.idPS);
};

// Nessuna normalizzazione al caricamento: questa funzione gestisce solo un cambio manuale.
export function applicaCambioSpedizione(prodotto, path, value, config) {
  const previous = String(_.get(prodotto, path) ?? "");
  const next = String(value ?? "");
  if (previous === next) return { prodotto, avviso: null };

  const update = _.set(_.cloneDeep(prodotto), path, next);
  const result = { prodotto: update, avviso: null };
  if (path !== FASCIA_SPEDIZIONE_PATH && path !== METODO_SPEDIZIONE_PATH) return result;

  const fascia = optionId(config, "fasciaPrezziSpedizione", "58,90 (49,90+9)");
  const ingombranti = optionId(config, "metodoSpedizione", "INGOMBRANTI_ASSICURATI");
  const standard = optionId(config, "metodoSpedizione", "STANDARD");
  if (fascia === null || ingombranti === null || standard === null) return result;

  let autoPath;
  let autoValue;
  let testo;
  if (path === FASCIA_SPEDIZIONE_PATH && next === fascia) {
    autoPath = METODO_SPEDIZIONE_PATH;
    autoValue = ingombranti;
    testo = "valorizzo automaticamente metodo su ingombranti assicurati";
  } else if (path === METODO_SPEDIZIONE_PATH && next === ingombranti) {
    autoPath = FASCIA_SPEDIZIONE_PATH;
    autoValue = fascia;
    testo = "valorizzo automaticamente spedizione a 58,90";
  } else if (
    (path === FASCIA_SPEDIZIONE_PATH && previous === fascia) ||
    (path === METODO_SPEDIZIONE_PATH && previous === ingombranti)
  ) {
    autoPath = METODO_SPEDIZIONE_PATH;
    autoValue = standard;
    testo = "valorizzo automaticamente metodo su standard";
  } else {
    return result;
  }

  // Avviso solo se il valore viene davvero cambiato (es. non quando l'utente sceglie STANDARD da sé).
  if (String(_.get(update, autoPath) ?? "") === autoValue) return result;
  _.set(update, autoPath, autoValue);
  return {
    prodotto: update,
    avviso: { campo: autoPath.split(".")[2], testo },
  };
}
